import { AnamnesisSurveyGroup } from '@higo/common/src/features/ExaminationPage/sections/AnamnesisSection/AnamnesisSurveyGroup';
import { FormattedMessage } from 'react-intl';
import { SurveyRenderer } from '@higo/common/src/features/FilledSurvey';
import { TaggedAnsweredQuestionMap } from '@higo/common/src/features/FilledSurvey/model';
import { FC } from 'react';

export interface AnamnesisMedicamentsSegmentProps {
  anamnesisTaggedQuestions?: TaggedAnsweredQuestionMap;
  generalTaggedQuestions?: TaggedAnsweredQuestionMap;
}
export const AnamnesisMedicamentsSegment: FC<AnamnesisMedicamentsSegmentProps> =
  ({ anamnesisTaggedQuestions, generalTaggedQuestions }) => {
    const bothMedicamentsEmpty =
      anamnesisTaggedQuestions?.A_MEDICAMENTS &&
      anamnesisTaggedQuestions?.A_MEDICAMENTS[0]?.answer === null &&
      generalTaggedQuestions?.G_MEDICAMENTS &&
      generalTaggedQuestions?.G_MEDICAMENTS[0]?.answer === null;

    return (
      <>
        {bothMedicamentsEmpty && (
          <AnamnesisSurveyGroup
            title={<FormattedMessage id="anamnesisSurvey.patientMedicaments" />}
            className="anamnesis-medicaments-segment"
          >
            {anamnesisTaggedQuestions?.A_MEDICAMENTS && (
              <SurveyRenderer
                answeredQuestionsList={anamnesisTaggedQuestions.A_MEDICAMENTS}
              />
            )}
          </AnamnesisSurveyGroup>
        )}
        {!bothMedicamentsEmpty &&
          (anamnesisTaggedQuestions?.A_MEDICAMENTS ||
            generalTaggedQuestions?.G_MEDICAMENTS) && (
            <AnamnesisSurveyGroup
              title={
                <FormattedMessage id="anamnesisSurvey.patientMedicaments" />
              }
              className="anamnesis-medicaments-segment"
            >
              {anamnesisTaggedQuestions?.A_MEDICAMENTS && (
                <SurveyRenderer
                  answeredQuestionsList={anamnesisTaggedQuestions.A_MEDICAMENTS}
                />
              )}

              {generalTaggedQuestions?.G_MEDICAMENTS && (
                <SurveyRenderer
                  answeredQuestionsList={generalTaggedQuestions.G_MEDICAMENTS}
                />
              )}
            </AnamnesisSurveyGroup>
          )}
      </>
    );
  };
